import { AwaitingPage } from './awaiting-validation/awaiting';
import { ClubMembersPage } from './club-members/club-members';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController } from 'ionic-angular';
import { Chart } from "chart.js";
import { DashboardPage } from '../dashboard/dashboard';
import { DashboardProvider } from '../../../providers/dashboard/dashboard';
import { ClubProvider } from '../../../providers/club/club';


@IonicPage()
@Component({
  selector: 'page-clubs',
  templateUrl: 'clubs.html',
})
export class ClubsPage {

  tabEmployer1 = DashboardPage;

  // Vars
  clubStats:any = {
    nonSponsoredClubs : 0,
    sponsoredClubs : 0,
    totalBudget : 0,
    membersAmount : 0,
    averageMembers : 0,
  };
  clubList:any;

  @ViewChild("lineCanvas") lineCanvas: ElementRef;
  private lineChart: Chart;


  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController, public dashboardProvider: DashboardProvider, public clubProvider: ClubProvider) {
    menu.enable(true);
  }

  ionViewDidLoad() {
    this.fetchClubs();
  }

  scrollToClubs(){
    let b = document.getElementById('clubsList');
    if (b) b.scrollIntoView()
  }

  getClubMembers(clubId) {
    let modal = this.modalCtrl.create(ClubMembersPage, {clubId});
    modal.present().then(() => {});
  }

  awaitingOpen(){
    let modal = this.modalCtrl.create(AwaitingPage);
    modal.present().then(() => {});
  }

  ngOnInit() {
    this.fetchClubs();
    this.loadClubStats();
    this.generateChart();
  }

  loadClubStats() {
    this.dashboardProvider.clubStats().subscribe((res) => {
      if(res.success){
        this.clubStats = res.data;
      }
    })
  }

  fetchClubs(){
    this.clubProvider.getAll().subscribe((res) => {
      if(res.success){
        this.clubList = res.data;
      }
    })
  }


  generateChart() {
    // this.lineChart = new Chart(this.lineCanvas.nativeElement, {
    //   type: "bar",
    //   data: {
    //     labels: ["Jan 20", "Fev 20", "Mar 20", "Avr 20", "Mai 20", "Jui 20", "Juil 20"],
    //     datasets: [
    //       {
    //         label: "évènement(s)",
    //         fill: false,
    //         lineTension: 0.1,
    //         borderColor: "rgba(75,192,192,1)",
    //         borderCapStyle: "butt",
    //         borderDash: [],
    //         backgroundColor: ["#DBEAF1", "#AED3E5","#2787B7","#035D8F","#024669", "#024669", "#AED3E5"],
    //         borderDashOffset: 0.0,
    //         borderJoinStyle: "miter",
    //         pointBorderColor: "rgba(75,192,192,1)",
    //         pointBackgroundColor: "#fff",
    //         pointBorderWidth: 1,
    //         pointHoverRadius: 5,
    //         pointHoverBackgroundColor: "rgba(75,192,192,1)",
    //         pointHoverBorderColor: "rgba(220,220,220,1)",
    //         pointHoverBorderWidth: 2,
    //         pointRadius: 1,
    //         pointHitRadius: 10,
    //         data: [1, 3, 2, 4, 6, 2, 1],
    //         spanGaps: false
    //       }
    //     ]
    //   },
    //   options: {
    //     legend: {
    //       display: false,
    //     },
    //     tooltips: {
    //       displayColors: false,
    //       callbacks: {
    //         title: function(tooltipItems, data) {
    //           return;
    //         },
    //         label: function(tooltipItem, data) {
    //           var datasetLabel = '';
    //           var label = data.labels[tooltipItem.index];
    //           return tooltipItem.yLabel;
    //         }
    //       }
    //     },
    //     tooltipTemplate: "<%= value %>",
    //     onAnimationComplete: function () {
    //         this.showTooltip(this.datasets[0].bars);
    //     },

    //     tooltipEvents: [],

    //     showAllTooltips: true,
    //     responsive: true,
    //     scales: {
    //       yAxes: [{
    //         ticks: {
    //           beginAtZero: true,
    //           userCallback: function (label, index, labels) {
    //             if (Math.floor(label) === label) {
    //               return label;
    //             }
    //           },
    //         }
    //       }],
    //     },
    //   }
    // });
  }

      // Decoding image buffer
      ab2str(arraybuffer) {
        return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
      }

}



// WEBPACK FOOTER //
// ./src/pages/employer/clubs/clubs.ts